/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {
  // SETTINGS
  const CART_ICON_SELECTOR = 'header a[href^="/cart"], [data-drawer-trigger="cart"]';
  const ADD_BTN_SELECTOR = 'button[name="add"], .product-form__submit, .add-to-cart, [data-add-to-cart], .cro-custom-btn';

  // 1. VISUALS: Add Loading State
  document.addEventListener('click', function(e) {
    const btn = e.target.closest(ADD_BTN_SELECTOR);
    if (!btn) return;
    btn.classList.add('btn--loading');
  });

  // 2. ACTION: Open Drawer
  function handleSuccess() {
    setTimeout(() => {
      const cartIcon = document.querySelector(CART_ICON_SELECTOR);
      if (cartIcon) {
        // OPTIONAL SAFETY CHECK: 
        // Only click if drawer is NOT already open (checks for common theme classes)
        const isAlreadyOpen = document.body.classList.contains('js-drawer-open') || 
                              document.body.classList.contains('is-drawer-open');
        
        if (!isAlreadyOpen) {
            cartIcon.click();
        }
      }

      document.querySelectorAll('.btn--loading').forEach(btn => {
         btn.classList.remove('btn--loading');
      });
    }, 1000); 
  }

  // 3. NETWORK INTERCEPTOR: Fetch
  const originalFetch = window.fetch;
  window.fetch = function() {
    return originalFetch.apply(this, arguments).then((response) => {
      if (response.url && (response.url.includes('/cart/add') || response.url.includes('/cart/add.js'))) {
        
        // --- FIX: IGNORE UPSELL REQUESTS ---
        if (response.url.includes('stealth=true')) {
            return response; // Exit immediately, do not trigger handleSuccess
        }
        // -----------------------------------

        const clone = response.clone();
        clone.json().then(data => {
          if (data.id || data.items) {
             handleSuccess();
          }
        }).catch(() => {});
      }
      return response;
    });
  };

  // 4. NETWORK INTERCEPTOR: XHR
  const originalOpen = XMLHttpRequest.prototype.open;
  const originalSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function(method, url) {
    this._url = url; 
    return originalOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function() {
    this.addEventListener('load', function() {
      if (this._url && (this._url.includes('/cart/add') || this._url.includes('/cart/add.js'))) {
        
        // --- FIX: IGNORE UPSELL REQUESTS ---
        if (this._url.includes('stealth=true')) {
            return; // Exit immediately
        }
        // -----------------------------------

        if (this.status >= 200 && this.status < 300) {
           handleSuccess();
        }
      }
    });
    return originalSend.apply(this, arguments);
  };

})();
